import Skeleton from "react-loading-skeleton";
import React from "react";
import Carousel from "react-multi-carousel";
import {crossSellResponsive} from "../utils/helpers";
import {Card} from "react-bootstrap";

export const SkeletonCarousel = ({title}: { title?: string | React.JSX.Element }) => {
    return (
        <Card body className="my-3 py-3">
            {title ? title : <Skeleton height={25} count={.4}/>}
            <Carousel
                swipeable={false}
                draggable={false}
                showDots={false}
                responsive={crossSellResponsive}
                ssr={false}
                infinite={true}
                partialVisbile={false}
                keyBoardControl={false}
                transitionDuration={500}
                containerClass="container-with-dots"
                dotListClass="custom-dot-list-style"
                itemClass="px-3"
            >
                <Item/>
                <Item/>
                <Item/>
                <Item/>
                <Item/>
            </Carousel>
        </Card>
    );
};

const Item = () => {
    return (
        <div className="p-3">
            <Skeleton height={50}/>
            <Skeleton count={2}/>
            <Skeleton count={2} height={25}/>
            <Skeleton height={50}/>
        </div>
    );
}